export const BuilderQuizSignUpErrors = {
  BIRTHDAY_REQUIRED: 'BIRTHDAY_REQUIRED',
  BIRTHDAY_INVALID: 'BIRTHDAY_INVALID',
  ZIP_CODE_INVALID: 'ZIP_CODE_INVALID',
  ZIP_CODE_REQUIRED: 'ZIP_CODE_REQUIRED',
  REFERRER_REQUIRED: 'REFERRER_REQUIRED',
  BOTTOM_SIZE_REQUIRED: 'BOTTOM_SIZE_REQUIRED',
  BRA_SIZE_REQUIRED: 'BRA_SIZE_REQUIRED',
  TOP_SIZE_REQUIRED: 'TOP_SIZE_REQUIRED',
  BAND_SIZE_REQUIRED: 'BAND_SIZE_REQUIRED',
  CUP_SIZE_REQUIRED: 'CUP_SIZE_REQUIRED',
  BRALETTE_SIZE_REQUIRED: 'BRALETTE_SIZE_REQUIRED',
  LINGERIE_SIZE_REQUIRED: 'LINGERIE_SIZE_REQUIRED',
};

export const BuilderQuizSignupErrorObjects = {
  REFERRER_REQUIRED: {
    id: 'quiz.sizing_screen_referrer_required',
    defaultMessage: 'Referrer is required',
  },
};
